export default __webpack_public_path__ + "static/media/Strugani 1.e7c097b8.jpg";